// @flow
import { array, object, string } from 'yup';
import { getIn } from 'formik';
import { isEqual } from 'lodash';

import {
  NATIVE_INFERENCE_POOL_MODEL_BACKEND_NAME,
  NATIVE_INFERENCE_POOL_PROVIDER_BACKEND_NAME,
  NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG,
} from '../../../constants';
import { getMonthlyInputsValidationFuncForType } from '../../cluster/cluster-details-inputs/kafka-monthly-inputs-validation';
import { clusterMonthlyDataInputTransformationFunc } from '../../cluster/cluster-input-table/utils';

export const nativeInferencePoolTokenModelsInputTransformFunc = (originalData) => {
  const dataToUse = originalData ?? [];

  const modelsTransformed = dataToUse.map((model) => ({
    modelId: model.model_id,
    modelName: model.name,
    modelLabel: model.name,
    months: clusterMonthlyDataInputTransformationFunc(model).months,
  }));

  return { models: modelsTransformed };
};

export const nativeInferencePoolTokenBasedModelsValidationFunc = ({
  estimate,
  nativeInferencePoolDetails,
}) => {
  const monthsSchema = getMonthlyInputsValidationFuncForType(
    NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG
  )({ estimate });

  const modelDetailsList = nativeInferencePoolDetails?.native_inference_configs?.model_types ?? [];

  const modelSchemaObject = monthsSchema.concat(
    object({
      modelName: string()
        .label('Model')
        .required()
        .test(
          'modelNotFound',
          'This model is not valid for the chosen provider! Please delete!',
          (value, { createError, path, from }) => {
            const formValues = from[2].value;
            const validOptions = modelDetailsList.filter(
              (modelDetail) =>
                modelDetail.provider === formValues[NATIVE_INFERENCE_POOL_PROVIDER_BACKEND_NAME] &&
                modelDetail[NATIVE_INFERENCE_POOL_MODEL_BACKEND_NAME] === value
            );

            const isError = validOptions.length === 0;
            if (isError) {
              return createError({
                message: 'This model is not valid for the chosen provider! Please delete!',
                path: path,
              });
            }
            return true;
          }
        ),
      modelLabel: string().label('Model Label').nullable(),
    })
  );

  return object({
    models: array(modelSchemaObject).notRequired().default([]),
  });
};

const isNativeInferencePoolTokenModelBeingEdited = (modelIndex, initialValues, values) => {
  const keyNameInValuesToUseForThisModel = `${NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG}.models[${modelIndex}]`;
  const modelOriginalData = getIn(initialValues, keyNameInValuesToUseForThisModel);
  const modelCurrentData = getIn(values, keyNameInValuesToUseForThisModel);
  return !isEqual(modelOriginalData, modelCurrentData);
};

export const isAnyOtherNativeInferencePoolTokenModelBeingEdited = (
  totalNumberOfModels,
  initialValues,
  values,
  modelIndex
) => {
  for (let i = 0; i <= totalNumberOfModels - 1; i++) {
    if (i === modelIndex) {
      continue;
    }
    if (isNativeInferencePoolTokenModelBeingEdited(i, initialValues, values)) {
      return true;
    }
  }
  return false;
};

export const getNativeInferencePoolTokenBasedModelsData = (values) => {
  return getIn(values, [NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG, 'models']) ?? [];
};

export const getUsedNativeInferencePoolTokenBasedModelNames = (modelsData) => {
  return modelsData.map((model) => model.modelName);
};
